import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { IInstallationFieldProps } from "./InstallationField.props";

export const useInstallationFieldControl = (props: IInstallationFieldProps) => {
  const [date, setDate] = useState<number | undefined>(props.installDate);

  useEffect(() => {
    if (props.installDate) {
      setDate(dayjs(Number(props.installDate) * 1000).valueOf());
    }
  }, [props.installDate]);

  const getDate = (d: dayjs.Dayjs | null) => {
    const unix = dayjs(d).valueOf();
    setDate(unix);

    props.getDate?.(unix);
  };

  return {
    date,

    getDate,
  };
};
